import { load } from 'js-yaml';

export type YamlContent = {
  title?: string;
  text?: string;
};

export type YamlSlug = 'kontakt' | 'rechtliches' | 'datenschutz' | 'impressum';

export async function loadYaml(slug: YamlSlug): Promise<YamlContent> {
  const res = await fetch(`/data/${slug}.yaml`);

  if (!res.ok) {
    throw new Error(`Konnte ${slug}.yaml nicht laden`);
  }

  const text = await res.text();
  const data = load(text);

  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    throw new Error(`Ungültige YAML-Struktur in ${slug}.yaml`);
  }

  const { title, text: body } = data as Partial<YamlContent>;

  return {
    title: title ?? slug,
    text: body ?? '',
  };
}
